<template>
  <v-row class="pa-6">
    <v-col cols="12">
      <v-card>
        <v-card-title>
          <div class="flex-grow-1">Quality Gaps</div>
          <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :loading="loading" :headers="headers" :items="provider_data" :search="search">
          <template v-slot:no-data> No Quality Gaps </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios';

export default {
  name: 'QualityGaps',
  props: ['provider', 'insurance', 'startDate', 'endDate'],
  data() {
    return {
      search: '',
      loading: false,
      headers: [],
      provider_data: [],
    };
  },
  mounted() {
    this.getClaims();
  },
  methods: {
    async log() {
      console.log(this.insurance);
      console.log(this.provider);
    },
    async getClaims() {
      this.provider_data = [];
      this.loading = true;

      // *** IN CASE WE NEED TO USE THESE LATER
      // const startDate = new Date(new Date().getFullYear(), 0, 1).toISOString().substring(0, 7);
      // const endDate = new Date(new Date().getFullYear(), 11, 31).toISOString().substring(0, 7);

      console.log(this.startDate);
      await axios
        .get(
          `api/quality/qualitygaps/orgs=/groups=/providers=${this.provider}/locs=/${this.insurance}/${this.startDate}/${this.endDate}`
        )
        .then((response) => {
          console.log(response);
          this.provider_data = response.data;
          this.setHeaders();
          this.loading = false;
        });
    },
    async setHeaders() {
      this.headers = [
        { text: 'Member Id', value: 'Member_Id' },
        { text: 'Patient Name', value: 'PATIENT_NAME' },
        { text: 'DOB', value: 'DOB' },
        { text: 'Phone Number', value: 'MEMBER_PHONE_NO' },
        { text: 'pcp id', value: 'pcp_id' },
        { text: 'PCP Name', value: 'PCP_Name' },
        { text: 'PCP ADD SUFF', value: 'PCP_Add_Suff' },
        { text: 'PCP Address', value: 'PCP_ADDRESS' },
        { text: 'Wellness Visit', value: 'WELL_VISIT' },
        { text: 'ART', value: 'RA_DRUG_TX' },
        { text: 'OMW', value: 'OSTEO_MGMT' },
        { text: 'CDC2_NPH', value: 'DM_NEPHRO' },
        { text: 'DM Ldl Cholesterol Screening', value: 'DM_LDL_C_Scrn' },
        { text: 'DM Ldl Cholesterol Level', value: 'DM_LDL_C_LVL' },
        { text: 'CDC2_EYE', value: 'DM_Eye_Exam' },
        { text: 'Colorectal Cancer Screening (COL)', value: 'Colon_CA_SCRN' },
        { text: 'DM Ldl Cholesterol Screening', value: 'CV_LDL_C_SCRN' },
        { text: 'COA_MDR', value: 'COA_RX_REVIEW' },
        { text: 'COA_PNS', value: 'COA_PAIN_ASMT' },
        { text: 'COA_FSA', value: 'COA_FSA' },
        { text: 'COA_ACP', value: 'COA_ADV_CARE_PLAN' },
        { text: 'Breast Cancer Screening (BCS)', value: 'BREAST_CANCER_SCRN' },
      ];
    },
  },
  watch: {
    async startDate() {
      this.getClaims();
    },
    async endDate() {
      this.getClaims();
    },
  },
};
</script>
